export const INDUSTRIES = [
  "Landscaping",
  "Roofing",
  "Plumbing",
  "HVAC",
  "Electrical",
  "Construction / General Contracting",
  "Cleaning / Janitorial Services",
  "Property Management",
  "Pest Control",
  "Other",
];
